module.exports = __webpack_public_path__ + "img/book-01.50d38ade.png";